<template>
  <div v-if="data">
    <a @click="getFile">
      {{ data.fileName }}
    </a>
    <v-progress-circular
      style="width:14px; height:14px"
      class="ml-2"
      v-if="loading"
      indeterminate
      color="primary"
    ></v-progress-circular>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import config from '@/config'
import api from '@/api'
export default {
  props: ['value'],
  data() {
    return {
      data: null,
      loading: false
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    })
  },
  mounted() {
    if (this.value) {
      this.data = JSON.parse(this.value)
    }
  },
  methods: {
    async getFile() {
      window.open(`${config.serverUrl}line/content/file/${this.selectedBot.pageid}/${this.data.id}`)
      // this.loading = true
      // var res = await api.getFile({ pageid: this.selectedBot.pageid, fileid: this.data.id })
      // if (res) {
      //   this.loading = false
      //   const blob = new Blob([res], { type: 'application/pdf' })
      //   const link = document.createElement('a')
      //   link.href = URL.createObjectURL(blob)
      //   link.download = this.data.fileName
      //   link.click()
      //   URL.revokeObjectURL(link.href)
      // } else {
      //   this.loading = false
      // }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/elements/FileType.vue